import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectPanoramaImageAndUploadByFlightId } from "features/entity-caching/images/panorama/selectors"
import { selectActivatedFireId } from "features/map/control/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useLazyLoadedImage } from "@nova/toolkit-pure-hooks"
import { GenericBlobUrlAssetsThumbnail } from "../generics/genericAssetsListThumbnails"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { useCallback } from "react"

export function PanoramaAssetsThumbnail({ id }: { id: string }) {
    const orgId = useAppSelector(selectActiveWorkspaceId()) || ""
    const fireId = useAppSelector(selectActivatedFireId) || ""
    const images = useAppSelector(selectPanoramaImageAndUploadByFlightId(id))
    const imageName = images[0]?.id
    const fetchBlob = useCallback(
        () =>
            fetchApiGateway(
                "get /org/:orgId/project/:projectId/flight/:flightId/panorama/:filename/preview",
                {
                    params: {
                        orgId,
                        projectId: fireId,
                        flightId: id,
                        filename: imageName || "",
                    },
                    headers: { Accept: "image/png" },
                    rawResponse: true,
                }
            ).then((res) => (res as Response).blob()),
        [orgId, fireId, id, imageName]
    )
    const { blobUrl, isFetching, containerRef, isError } = useLazyLoadedImage({
        type: "AssetsThumbnail",
        imageKey: id,
        fetchBlob,
    })
    return (
        <GenericBlobUrlAssetsThumbnail
            blobUrl={blobUrl}
            isFetching={isFetching}
            isError={isError}
            containerRef={containerRef}
            display="cover"
            pad={false}
        />
    )
}
